"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APIcon = _interopRequireDefault(require("../../../../common/APIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BuySellTabsComponent = function BuySellTabsComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var baseClasses = props.baseClasses,
    clearForm = props.clearForm,
    setBuyValue = props.setBuyValue,
    setSellValue = props.setSellValue,
    isBuySide = props.isBuySide,
    themeModifier = props.themeModifier;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('tab-wrapper')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('tab', {
      'buy-selected': isBuySide
    }),
    onClick: function onClick() {
      clearForm();
      setBuyValue();
    }
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "buy",
    classModifiers: "big",
    customClass: baseClasses('icon')
  }), t("Buy")), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('vertical-divider', themeModifier)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('tab', {
      'sell-selected': !isBuySide
    }),
    onClick: function onClick() {
      clearForm();
      setSellValue();
    }
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "sell",
    classModifiers: "big",
    customClass: baseClasses('icon')
  }), t("Sell")));
};
BuySellTabsComponent.propTypes = {
  baseClasses: _propTypes["default"].func.isRequired,
  setBuyValue: _propTypes["default"].func.isRequired,
  setSellValue: _propTypes["default"].func.isRequired,
  clearForm: _propTypes["default"].func.isRequired,
  isBuySide: _propTypes["default"].bool.isRequired,
  themeModifier: _propTypes["default"].string
};
var _default = exports["default"] = BuySellTabsComponent;